<template lang="pug">
#All

</template>

<script>
export default {
  name: 'All',

  mounted () {
  },

  methods: {
  }
}
</script>

<style lang="sass">

</style>
